module.exports = __webpack_public_path__ + "media/images/recruit/top/mv_women-5c4bb175098c92034de0b76df0fe102b.png";